import i18n from "src/i18n/config";

import { ColumnDef } from "@tanstack/react-table";

import { Rollout } from "../../types";

import { RolloutStatusCell } from "./RolloutStatusCell";
import { RolloutTableActionsCell } from "./RolloutTableActionsCell";
import { RolloutTableCell } from "./RolloutTableCell";
import { RolloutTableDateCell } from "./RolloutTableDateCell";

export const columns: ColumnDef<Rollout>[] = [
    {
        header: i18n.t("common:label.version"),
        accessorKey: "version",
        cell: (info) => <RolloutTableCell id={info.row.original.id} value={info.getValue<string>()} />,
    },
    {
        header: i18n.t("common:label.created"),
        accessorKey: "created",
        cell: (info) => <RolloutTableDateCell id={info.row.original.id} value={info.getValue<string>()} />,
    },
    {
        header: i18n.t("common:label.progress"),
        accessorKey: "progress",
        cell: (info) => <RolloutTableCell id={info.row.original.id} value={info.getValue<string>()} />,
    },
    {
        header: i18n.t("common:label.status"),
        accessorKey: "status",
        cell: (info) => <RolloutStatusCell id={info.row.original.id} status={info.getValue<Rollout["status"]>()} />,
    },
    {
        id: "actions",
        header: "",
        enableSorting: false,
        meta: { align: "right" },
        cell: ({ row }) => <RolloutTableActionsCell rollout={row.original} />,
    },
];

export const defaultParams = {
    pageIndex: 0,
    pageSize: 12,
    sortBy: "version",
    sortDescending: true,
};
